import axios from '@/plugins/axios';

export function listProject(params) {
  return axios.get('/project/listProject', {
    params: params
  });
}
export function newProject(params) {
  return axios.get('/project/newProject', {
    params: params
  });
}
export function getProjectByIdMsg(params) {
  return axios.get('/project/getProjectById', {
    params: params
  });
}
export function getProjectById(params) {
  return axios.get('/project/getProjectById', {
    params: params,
    transformResponse: [
      function(data) {
        let responseData = JSON.parse(data);
        if (responseData.returnCode === '05') {
          location.href = '/error/403';
        } else {
          return responseData;
        }
      }
    ]
  });
}
export function saveProject(params) {
  return axios.get('/project/saveProject', {
    params: params
  });
}

export function setProjectRuleTemplate(projectId, templateId) {
  return axios.post('/project/setProjectRuleTemplate', {
    projectId: projectId,
    templateId: templateId
  });
}
export function getProjectDetailByIdMsg(projectId) {
  return axios.get('/project/getProjectDetailById', {
    params: {
      projectId: projectId
    }
  });
}
// 根据项目id 获取项目详情
export function getProjectDetailById(projectId) {
  return axios.get('/project/getProjectDetailById', {
    params: {
      projectId: projectId
    },
    transformResponse: [
      function(data) {
        let responseData = JSON.parse(data);
        if (responseData.returnCode === '05') {
          location.href = '/error/403';
        } else {
          return responseData;
        }
      }
    ]
  });
}
export function editProject(params) {
  return axios.get('/project/editProject', {
    params: params
  });
}
export function ravocationProject(type, projectId, replyId, userId) {
  return axios.get('/project/ravocationProject', {
    params: {
      type: type,
      projectId: projectId,
      replyId: replyId,
      userId: userId
    }
  });
}
export function delay(params) {
  return axios.post('/project/delay', {
    delayDate: params.delayDate,
    delayDateHour: ' ',
    projectId: params.projectId
  });
}
export function getProjectAndReply(projectId, supplierUserId) {
  return axios.get('/project/getProjectAndReply', {
    params: {
      projectId: projectId,
      supplierUserId: supplierUserId
    }
  });
}
export function listBusiness(params) {
  return axios.post('/project/listBusiness', params);
}
/**
 * 获取招标项目明细
 * @param {number} projectId
 */
export function detailProjectResponse(projectId) {
  return axios.get('/project/detailProjectResponse', {
    params: {
      projectId: projectId
    },
    transformResponse: [
      function(data) {
        let responseData = JSON.parse(data);
        if (responseData.returnCode === '05') {
          location.href = '/error/403';
        } else if (responseData.returnCode === '04') {
          location.href = '/error/403';
        } else {
          return responseData;
        }
      }
    ]
  });
}
/**
 * 验证项目时间和状态
 * @param {number} projectId
 */
export function getTimeAndStauts(projectId) {
  return axios.get('/project/getTimeAndStauts', {
    params: {
      projectId: projectId
    },
    transformResponse: [
      function(data) {
        let responseData = JSON.parse(data);
        if (responseData.returnCode === '05') {
          location.href = '/error/403';
        } else {
          return responseData;
        }
      }
    ]
  });
}
export function myList(params) {
  return axios.post('/project/myList', params);
}
/**
 * 供应方查询项目
 * @param {number} projectId
 * @param {number} replyId
 */
export function detailProject(projectId, replyId) {
  return axios.get('/project/detailProject', {
    params: {
      projectId: projectId,
      replyId: replyId
    },
    transformResponse: [
      function(data) {
        let responseData = JSON.parse(data);
        if (responseData.returnCode === '05') {
          location.href = '/error/403';
        } else {
          return responseData;
        }
      }
    ]
  });
}
export function updateStatus(projectId, replyId, updateId) {
  return axios.get('/project/updateStatus', {
    params: {
      projectId: projectId,
      replyId: replyId,
      updateId: updateId,
      projectStatus: 7,
      quoteStatus: 6
    }
  });
}
export function isCheckSupplierBtnAuth(params) {
  return axios.post('/project/isSupBtnAuth', params);
}
